export const WHEN_TO_USE = `Purpose: make components of a dataset traversal required, so the
traversal only returns the context components that actually reach a component of that type
along that path.

Trigger: ONLY when the user explicitly asks to keep, show or return only the components that
have a connection to a component type in the current traversal or viewpoint (the user may call
it a "view"). Examples: "only show applications that have a server", "require the capability
in this view", "hide the applications without a database", "make the server mandatory".
A request to add a new relationship type, to filter by a field value, or to show or see
components is not this trigger.

After the call: confirm in one sentence which component types are now required.`;

export const REQUIRED_PATHS_DESCRIPTION = `'datasets' — the traversal datasets this tool can
change. Datasets the user has hidden, and datasets with no traversal steps, are absent; if the
user seems to mean one that is not listed, say you cannot change it instead of picking the
nearest one.

Each entry has:
- 'datasetId' — copy it back verbatim as 'datasetId' to name the dataset to change;
- 'viewpointName' — its saved viewpoint's name, null when the dataset is ad-hoc;
- 'paths' — the traversal's paths, each a list of steps from the context components outwards.
  A step goes from 'sourceType' over 'referenceType' to 'targetType'; when 'direction' is
  'incoming' the step is walked backwards, from the target to the source. The component type a
  step reaches is 'targetType' for 'outgoing' and 'sourceType' for 'incoming'. 'isRequired'
  tells whether that step is already required.

To require a component type, find the step that reaches it and send its 'pathIndex' (position
in 'paths') and 'stepIndex' (position in that path), both starting at 0. Several paths can
start with the same steps: any one of them names the step for all of them. If the type the user
names is reached by more than one step, ask which one they mean.`;
